import ClubShipDate from './ClubShipDate';

const MobileToggleSummary = (props) => {
  const { onToggleMobile, clubSubscriptionShipment } = props;
  const toggleMobileSummary = (e) => {
    e.preventDefault();
    onToggleMobile();
  };
  return (
    <div className="c7-checkout-template__toggle">
      <div onClick={toggleMobileSummary}>
        <ClubShipDate clubSubscriptionShipment={clubSubscriptionShipment} />
      </div>
    </div>
  );
};
export default MobileToggleSummary;
